import { ProgramNameGetterType } from "../types"

export const isCCMRProduct = (key: string) => {
  /*
  For CCMR programs, the APC team requires 'the' before the program name when referring to it directly.
  Example: 'Welcome to MasteryPrep for the TSIA2.'
  */
  return ["DSAT", "CLT", "TSIA2"].includes(key?.toUpperCase())
}

export const programNameGetter = (
  programAbbr: string,
  displayProgramName: string
): ProgramNameGetterType | null => {
  if (!programAbbr && !displayProgramName) return null

  const programName = displayProgramName || programAbbr?.toUpperCase() || ""
  const isCCMR = isCCMRProduct(programAbbr)

  return {
    // get() without params return just programName without processing
    get: function (options) {
      const {
        includeArticle = false,
        capitalizeArticle = false,
        dependsOnProduct = false
      } = options || {}

      if (includeArticle || (dependsOnProduct && isCCMR)) {
        return `${capitalizeArticle ? "The" : "the"} ${programName}`
      }

      return programName
    },
    documentHead: programName,
    isCCMRProduct: isCCMR
  }
}
